


















import Vue from 'vue'
import SocialStreamConfigsList from '@/views/components/socialStream/SocialStreamConfigsList.vue'

export default Vue.extend({
  components: {
    SocialStreamConfigsList
  },
  data() {
    return {
      socialStreamConfigs: {
        columns: [{ name: 'instagramHandle' }]
      }
    }
  },
  methods: {
    redirectToAddPage() {
      this.$router.push({ name: 'socialStreamConfigAdd' }).catch(() => {
      })
    },
  },
})
